import { getEligibilityErrorMessage } from './eligibilityErrors'
import {
  useDeleteLiveWork,
  useDeleteSuperMajority,
  useDeleteTraining,
  usePutLiveWork,
  usePutTraining,
  useResumeLiveWork,
  useSuspendLiveWork,
} from './useEligibility'

export const eligibility = {
  putTraining: usePutTraining,
  deleteTraining: useDeleteTraining,
  putLiveWork: usePutLiveWork,
  deleteLiveWork: useDeleteLiveWork,
  deleteSuperMajority: useDeleteSuperMajority,
  suspendLiveWork: useSuspendLiveWork,
  resumeLiveWork: useResumeLiveWork,
  getErrorMessage: getEligibilityErrorMessage,
}
